// @flow

// lib
import React from 'react';

// route
import proceed from './proceed';
import account from './account';
import welcome from './welcome';

const routes = [
  proceed,
  account,
  welcome,
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx